"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var locales = {};
['en', 'de', 'fr', 'es', 'pt', 'ja', 'zh'].forEach(function (lng) {
    // eslint-disable-next-line
    Object.assign(locales, require("./" + lng + ".js").default);
});
exports.default = locales;
//# sourceMappingURL=index.js.map